import { auditApi as api } from '../../api';

export const fetchVendorWiseRecord = async () => {
    try {
        const response = await api.get(`/get-vendor-wise-record`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

export const fetchFilterVendorWiseRecord = async (from_date,to_date) => {
  try {
      const response = await api.get(`/get-vendor-wise-filtered-data`, {
        params: {
          from_date: from_date,
          to_date:to_date
        }
    });
      return response.data;
  } catch (error) {
      throw error.response ? error.response.data.error : error.message;
  }
}
export const get_vendor_audit_details = async (id) => {
    try {
        const response = await api.get(`get-vendor-audit-details/${id}`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data.error : error.message;
    }
}

// export const updateVendorAudit = async (Data) => {
//     try {
//         console.log(Data);
//         const token = sessionStorage.getItem('token');
        // const response = await api.put(`/vendor-audit-details`, Data, {
        //     headers: {
        //         'Authorization': `Bearer ${token}`,
        //         'Content-Type': 'application/json'

        //     }
        // });
        // return response.data
//     } catch (error) {
//         throw error.response ? error.response.data.error : error.message;
//     }
// }



export const updateVendorAudit = async (status, Data) => {
  try {
    const token = sessionStorage.getItem('token');
    const formData = new FormData();

    // Prepare JSON payload
    const auditDetails = Data.data.map(item => ({
      id: item.id,
      remark: item.remark,
      auditors_remark: item.auditors_remark,
      status: item.status,
      attachment: typeof item.attachment === "string" ? item.attachment : item.attachment
    }));

    formData.append("data", JSON.stringify({ auditDetails }));
    formData.append("status", status);

    // === IMPORTANT PART ===
    // Send files as <id>[] so backend receives them using request.files.getlist(f"{id}[]")
    Data.data.forEach(item => {
      if (Array.isArray(item.attachment)) {
        item.attachment.forEach(file => {
          if (file instanceof File) {
            formData.append(`${item.id}`, file);
          }
        });
      }
    });

    // API
    const response = await api.put(`/vendor-audit-details`, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;

  } catch (err) {
    console.error("updateVendorAudit Error:", err);
    throw err;
  }
};

export const uploadVendorAuditAttachment = async (recordId, file, override = false) => {
  const token = sessionStorage.getItem("token");
  const formData = new FormData();
  formData.append("file", file);
  if (override) {
    formData.append("override", "true");
  }
  const response = await api.post(`/vendor-audit-details/${recordId}/attachment`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

export const clearVendorAuditDrafts = async (auditPk) => {
  const token = sessionStorage.getItem("token");
  const response = await api.post(`/vendor-audit/${auditPk}/drafts/clear`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const clearVendorAuditRowDrafts = async (recordId) => {
  const token = sessionStorage.getItem("token");
  const response = await api.post(`/vendor-audit-details/${recordId}/drafts/clear`, {}, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const clearVendorAuditAttachments = async (recordId) => {
  const token = sessionStorage.getItem("token");
  const response = await api.post(
    `/vendor-audit/attachment/delete`,
    { record_id: recordId, clear_all: true },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};
export const AttachmentFile = async (recordId, filePath) => {

  try {
    const token = sessionStorage.getItem("token");
    const response = await api.get(
      `/audit_service/${recordId}/${filePath}`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
      console.log(response);
    return response;

  } catch (err) {
    console.error("AttachmentFile Error:", err);
    throw err;
  }
};





// export const updateVendorAudit = async (status,Data) => {
//     try { 
//         const token = sessionStorage.getItem('token');
//         const formData = new FormData();
//         const auditDetails = Data.data.map(item => ({
//             id: item.id,
//             remark: item.remark,
//             ...(typeof item.attachment === "string" ? { attachment: item.attachment } : {})
//         }));
//         formData.append("data", JSON.stringify({ auditDetails }));
//         formData.append("status", status);
//         Data.data.forEach(item => {
//             if (Array.isArray(item.attachment) && item.attachment.length > 0) {
//                 item.attachment.forEach(file => {
//                   formData.append(`${item.id}[]`, file);
//                 });
//               }
//         });
//         const response = await api.put(`/vendor-audit-details`, formData, {
//             headers: {
//                 'Authorization': `Bearer ${token}`,
//                 'Content-Type': 'multipart/form-data'
//             }
//         });
 
//         return response.data;



        
//     } catch (error) {
//         console.error("❌ Error updating vendor audit:", error);
//         throw error.response ? error.response.data.error : error.message;
//     }
// };